export const txrclicenserenewal = {
  agencySlug: 'txrc',
  appCode: 'TXRC_LICENSERENEWAL',
  slug: 'txrc',
  linkService: {
    form: {
      labels: {
        licenseNumber: { id: 'txrc_licenseNumber' },
        lastName: { id: 'txrc_lastName' },
      },
    },
  },
};
